import { AfterViewInit, Component, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { LangChangeEvent, TranslatePipe, TranslateService } from "@ngx-translate/core";
import { WcmService } from "@shared/services/wcm/wcm.service";
import { SharedModule } from "@shared/shared.module";

@Component({
	template: '<section class="form"><h2>{{ "footer.legalNotices" | translate }}</h2><div class="box text-page" [innerHTML]="legalnotes"></div></section>',
	imports: [
		SharedModule,
		TranslatePipe
	],
	styleUrl: "./legal-notes.component.scss",
})
export class LegalNotesComponent implements AfterViewInit {
	protected legalnotes = "";
	// market: any;
	wcmService = inject(WcmService);

	translate = inject(TranslateService);
	constructor() {
		this.translate.onLangChange
			.pipe(takeUntilDestroyed())
			.subscribe(
				(event: LangChangeEvent) => {
					this.setData(event.lang);
				}
			);
	}
	private setData(lang: string) {
		this.wcmService.getDocument("legal-notes", lang)
			.subscribe({
				next: value => {
					this.legalnotes = value;
				},
				error: () => { this.legalnotes = ""; }
			});
	}
	ngAfterViewInit() {
		this.setData(this.translate.getCurrentLang());
	}
}